export default "__VITE_ASSET__C3ZS7deb__"